import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";

export class PocketReduction extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    // validate not missing
    if (!ItemValidators.notMissingTeeth(item, odontogram)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    const resolvedConditions = ["recession"];

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        const boneLossItems = tooth.diagnosis.filter(
          (_item) =>
            _item.condition === "bone-loss" ||
            _item.condition === "periodontitis",
        );

        if (boneLossItems.length > 0) {
          // has bone loss
          tooth.gengiva_normal = false;
          // move gengiva line
          tooth.diagnosis.push({
            condition: "recession",
            options: boneLossItems[0].options,
          });
        }
      });

    return odontogram;
  }

  static getIdentifier(): string {
    return "pocket-reduction";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/perio/pocket-reduction.ts